import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '@examsoft/es-login';
import { environment } from '@environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@examsoft/es-login";
var EulaService = /** @class */ (function () {
    function EulaService(http, authService) {
        this.http = http;
        this.authService = authService;
        this.agreementServiceURL = environment.urls.pltApiUrl + "/agreements-ui";
    }
    EulaService.prototype.hasAcceptedLatest = function (esId) {
        var requestOptions = {
            headers: new HttpHeaders({
                Authorization: this.authService.getJwt(),
                'Content-Type': 'application/json',
                'x-es-txn-id': esId
            })
        };
        return this.http.get(this.agreementServiceURL + "/" + esId + "?app=examnow&agreement=examnow_terms_and_conditions.html", requestOptions);
    };
    EulaService.prototype.acceptLatestAgreement = function (esId) {
        var requestOptions = {
            headers: new HttpHeaders({
                Authorization: this.authService.getJwt(),
                'Content-Type': 'application/json',
                'x-es-txn-id': esId
            })
        };
        return this.http.post(this.agreementServiceURL + "/" + esId, {
            app: 'examnow',
            agreement: 'examnow_terms_and_conditions.html',
            agreementAccepted: true,
            agreementAcceptedTimestamp: Date.now()
        }, requestOptions);
    };
    EulaService.ngInjectableDef = i0.defineInjectable({ factory: function EulaService_Factory() { return new EulaService(i0.inject(i1.HttpClient), i0.inject(i2.AuthService)); }, token: EulaService, providedIn: "root" });
    return EulaService;
}());
export { EulaService };
